/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { type Routes, RouterModule } from '@angular/router';
import { CoreModule } from '@dm/core';
import { TaskErrorDetailModule } from 'app/common/components/task-batch/task-error-detail/task-error-detail.module';

import { TaskComponent } from './task.component';
import { TaskCenterService } from './task-center.service';
import { TaskDetailComponent } from './task-detail/task-detail.component';
import { TaskStrService } from './task-str.service';

const routes: Routes = [{
    path: '',
    component: TaskComponent,
}];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        TaskErrorDetailModule,
    ],
    exports: [
        TaskComponent,
        TaskDetailComponent,
    ],
    declarations: [
        TaskComponent,
        TaskDetailComponent,
    ],
    providers: [
        TaskCenterService,
        TaskStrService,
    ],
})

export class TaskModuleEmbed { }

@NgModule({
    imports: [
        TaskModuleEmbed,
        RouterModule.forChild(routes),
    ],
})

export class TaskModule { }
